import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue')
    },
    {
      path: '/comunismul',
      name: 'comunismul',
      component: () => import('./views/Comunismul.vue')
    },
    {
      path: '/biserica',
      name: 'biserica',
      component: () => import('./views/Biserica.vue')
    },
    {
      path: '/banat',
      name: 'banat',
      component: () => import('./views/Banat.vue')
    },
    {
      path: '/timisoara',
      name: 'timisoara',
      component: () => import('./views/Timisoara.vue')
    },
    {
      path: '/resita',
      name: 'resita',
      component: () => import('./views/Resita.vue')
    },
    {
      path: '/anina',
      name: 'anina',
      component: () => import('./views/Anina.vue')
    },
    {
      path: '/banatDeutsche',
      name: 'banatDeutsche',
      component: () => import('./views/BanatDeutsche.vue')
    },
    {
      path: '/oravita',
      name: 'oravita',
      component: () => import('./views/Oravita.vue')
    },
    {
      path: '/oravitaAnina',
      name: 'oravitaAnina',
      component: () => import('./views/OravitaAnina.vue')
    },
    {
      path: '/transilvania',
      name: 'transilvania',
      component: () => import('./views/Transilvania.vue')
    },
    {
      path: '/sibiu',
      name: 'sibiu',
      component: () => import('./views/Sibiu.vue')
    },
    {
      path: '/brasov',
      name: 'brasov',
      component: () => import('./views/Brasov.vue')
    },
    {
      path: '/carpati',
      name: 'carpati',
      component: () => import('./views/Carpati.vue')
    },
    {
      path: '/olt',
      name: 'olt',
      component: () => import('./views/Olt.vue')
    },
    {
      path: '/maramures',
      name: 'maramures',
      component: () => import('./views/Maramures.vue')
    },
    {
      path: '/iasi',
      name: 'iasi',
      component: () => import('./views/Iasi.vue')
    },
    {
      path: '/bucuresti',
      name: 'bucuresti',
      component: () => import('./views/Bucuresti.vue')
    },
    {
      path: '/caileFerate',
      name: 'caileFerate',
      component: () => import('./views/CaileFerate.vue')
    },
    {
      path: '/eclipsa',
      name: 'eclipsa',
      component: () => import('./views/Eclipsa.vue')
    }
  ]
})
      
      
      
